<template>
  <div class="login-container">
    <div class="login-box">
      <el-card shadow="always">
        <div slot="header" class="login-header">
          <div class="logo-icon">🌿</div>
          <div class="title">生态哨兵后台登录</div>
        </div>
        <el-form :model="form">
          <el-form-item label="用户名">
            <el-input v-model="form.username" placeholder="请输入用户名" />
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="form.password" type="password" placeholder="请输入密码" @keyup.enter.native="submit" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" style="width:100%;" @click="submit">登录</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { adminLogin } from '@/api'

export default {
  data () {
    return {
      loading: false,
      form: {
        username: 'admin',
        password: ''
      }
    }
  },
  methods: {
    async submit () {
      if (this.loading) return
      this.loading = true
      try {
        const res = await adminLogin(this.form)
        localStorage.setItem('admin_token', res.data.token)
        this.$store.commit('setAdminInfo', res.data.adminInfo)
        this.$router.replace('/dashboard')
      } catch (e) {
        this.$message.error(e.message || '登录失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.login-container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: moveBackground 20s linear infinite;
}

@keyframes moveBackground {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

.login-box {
  width: 420px;
  position: relative;
  z-index: 1;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-box .el-card {
  border-radius: 12px;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
}

.login-header {
  text-align: center;
  padding: 10px 0;
}

.logo-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  letter-spacing: 1px;
}

.login-box .el-form {
  padding: 20px 10px 10px;
}

.login-box .el-form-item {
  margin-bottom: 24px;
}
</style>
